import { render, staticRenderFns } from "./dialog-relation.vue?vue&type=template&id=a69a6c26&"
import script from "./dialog-relation.vue?vue&type=script&lang=js&"
export * from "./dialog-relation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports